<template>
  <div>
    <section class="header">
      GTV：{{ totalGtv }} 元
    </section>
    <van-list v-if="poiList && poiList.length>0">
      <div
        v-for="item in poiList"
        :key="`${item.poiId}-${item.billMonth}`"
        class="cell-card"
        @click="onClickCell(item)"
      >
        <div class="title">
          <span class="left">{{ item.billMonth|formatYearMonth }}</span>
          <span class="middle">{{ item.poiName }}</span>
          <span class="right">查看明细</span>
        </div>
        <div class="gtv">
          GTV：{{ item.divideGtv }} 元
        </div>
      </div>
    </van-list>
    <div v-else>
      暂无数据
    </div>
  </div>
</template>

<script>
import { List } from 'vant';
import ActivityApi from '@/api/activity';
import STATUS from '@/constants/status';
import { formatYearMonth } from '@/util/filter';

export default {
  name: 'MonthBillDetail',
  components: {
    [List.name]: List,
  },
  filters: {
    formatYearMonth(value) {
      if (value) {
        return formatYearMonth(`${value}`);
      }
      return '-';
    },
  },
  data() {
    return {
      totalGtv: '-',
      poiList: [],
    };
  },
  created() {
    const { activityId, billMonth, customerId } = this.$route.query;
    this.getActivityMonthGTV(customerId, activityId, billMonth);
  },
  methods: {
    async getActivityMonthGTV(customerId, activityId, billMonth) {
      try {
        this.$dialog.loading.show();
        const { code, data } = await ActivityApi.getActivityMonthGTV(customerId, activityId, billMonth);
        if (code === STATUS.SUCCESS) {
          this.totalGtv = data.totalGtv || 0;
          this.poiList = data.poiList || [];
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.$dialog.loading.hide();
      }
    },
    onClickCell({ poiId, poiName }) {
      this.$router.push(
        {
          name: 'ActivityPoiMonthBillDetail',
          query: {
            ...this.$route.query,
            poiId,
            poiName,
          },
        },
      );
    },
  },
};
</script>

<style lang="scss" scoped>
  .header {
    text-align: left;
    margin: 0.36rem 0 0 0.36rem;
  }
  .cell-card {
    .title{
      display: flex;
      align-items: center;

      .left{
        font-weight: bold;
      }
      .middle {
        flex: 1;
        padding: 0 0.18rem;
        text-align: left;
      }
      .right {
        color: blue;
      }
    }

    .gtv {
      margin-top: 0.2rem;
      text-align: right;
    }
  }
</style>
